// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as V2EventsContext$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/v2/V2EventsContext.res.mjs";

function call(f) {
  Belt_Option.map(f, (function (f) {
          return f();
        }));
}

function callWith(f, x) {
  Belt_Option.map(f, (function (f) {
          return f(x);
        }));
}

function callWith2(f, x, y) {
  Belt_Option.map(f, (function (f) {
          return f(x, y);
        }));
}

function wrapApiWithStoreEvents(api, dispatch, disableResponseMarking, onActivityCompleted, onActivityReachedEnd, onActivityStarted, onExit, onQuestionFailed, onQuestionPassed, onQuestionStarted, param) {
  return api((function (accuracy) {
                dispatch("ActivityCompleted");
                callWith(onActivityCompleted, accuracy);
              }), (function (param) {
                dispatch("ActivityReachedEnd");
                call(onActivityReachedEnd);
              }), (function (param) {
                dispatch("ActivityStarted");
                call(onActivityStarted);
              }), (function (questionIndex, serializedState) {
                dispatch("Exit");
                callWith2(onExit, questionIndex, serializedState);
              }), (function (responsePayload) {
                dispatch({
                      TAG: "QuestionFailed",
                      question: responsePayload.questionIndex + 1 | 0,
                      responsesCorrect: disableResponseMarking ? undefined : responsePayload.responsesCorrect,
                      responsesComplete: disableResponseMarking ? undefined : responsePayload.responsesComplete
                    });
                callWith(onQuestionFailed, responsePayload);
              }), (function (responsePayload) {
                dispatch({
                      TAG: "QuestionPassed",
                      question: responsePayload.questionIndex + 1 | 0,
                      responsesCorrect: disableResponseMarking ? undefined : responsePayload.responsesCorrect,
                      responsesComplete: disableResponseMarking ? undefined : responsePayload.responsesComplete
                    });
                callWith(onQuestionPassed, responsePayload);
              }), (function (questionIndex, serializedState) {
                dispatch("QuestionStarted");
                callWith2(onQuestionStarted, questionIndex, serializedState);
              }));
}

function api(onActivityCompleted, onActivityReachedEnd, onActivityStarted, onExit, onQuestionFailed, onQuestionPassed, onQuestionStarted) {
  return {
          onActivityCompleted: onActivityCompleted,
          onActivityReachedEnd: onActivityReachedEnd,
          onActivityStarted: onActivityStarted,
          onExit: onExit,
          onQuestionFailed: onQuestionFailed,
          onQuestionPassed: onQuestionPassed,
          onQuestionStarted: onQuestionStarted
        };
}

function FlipperTupperwareCallbacks$Provider(props) {
  return React.createElement(V2EventsContext$LiteracyplanetClientLibsActivity.make, {
              value: props.dispachables,
              children: props.children
            });
}

var Provider = {
  make: FlipperTupperwareCallbacks$Provider
};

export {
  call ,
  callWith ,
  callWith2 ,
  wrapApiWithStoreEvents ,
  api ,
  Provider ,
}
/* react Not a pure module */
